import styled from '@emotion/styled';
import DOMPurify from 'dompurify';
import PropTypes from 'prop-types';
import React from 'react';

const SafeHtmlStyle = styled.span`
    /* white-space: pre-line respects the newline characters that occur when user hits the Enter key */
    white-space: pre-line;
`;

function sanitizeUnsafeHtml(input) {
    return DOMPurify.sanitize(input, { FORBID_TAGS: ['script'], ADD_ATTR: ['target'] });
}

const SafeHtmlOnly = ({ children, className }) => {
    if (!children) {
        return null;
    }
    return <SafeHtmlStyle className={className} dangerouslySetInnerHTML={{ __html: sanitizeUnsafeHtml(children) }} />;
};

SafeHtmlOnly.propTypes = {
    children: PropTypes.node,
    className: PropTypes.string,
};
SafeHtmlOnly.defaultProps = {
    className: '',
    children: null,
};

export default SafeHtmlOnly;
